import { render, staticRenderFns } from "./contacts-comment.vue?vue&type=template&id=74f931bc&scoped=true&"
import script from "./contacts-comment.vue?vue&type=script&lang=js&"
export * from "./contacts-comment.vue?vue&type=script&lang=js&"
import style0 from "./contacts-comment.vue?vue&type=style&index=0&id=74f931bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f931bc",
  null
  
)

export default component.exports